import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/admins";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/user/dropdown/Admin";
const apiInviteEndPoint=API_BASE_URL_ENV() + "/admin/user/invite"
const apiTogglle=API_BASE_URL_ENV() +"/admin/user/toggle-activation/Admin"
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    
    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
      inviteAdmin=(data)=>{
        return  http.post(apiInviteEndPoint,data) 

      }
      toggleStatus(id) {
        return http.get(`${apiTogglle}/${id}`);
      }
 
   
}
